/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BellSimpleSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M213.91992,210.61816a8.0006,8.0006,0,0,1-11.83984,10.76368l-19.45654-21.40235H48.9834A15.99885,15.99885,0,0,1,35.18652,175.915c5.9375-10.21484,13.0166-29.59961,13.0166-63.93555v-8a79.6939,79.6939,0,0,1,10.7212-40.06885L42.08008,45.38184A8.0006,8.0006,0,1,1,53.91992,34.61816ZM160,215.97949H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm42.90039-41.2666a8.0004,8.0004,0,0,0,13.36328-8.31445c-5.61328-14.24414-8.459-32.55274-8.459-54.41895v-7.09668c0-44.28515-35.52735-80.57715-79.19629-80.90136A79.49567,79.49567,0,0,0,88.5332,34.43652,8.00109,8.00109,0,0,0,86.583,46.76367Z" />
    </Svg>
  );
}

export default BellSimpleSlash;
